import axios from "axios";
import { getApiBaseUrl } from "./config";

export const SESSION_EXPIRED_FLAG = "sessionExpired";
window.__SOPHY_SESSION_EXPIRY_IN_PROGRESS__ =
  window.__SOPHY_SESSION_EXPIRY_IN_PROGRESS__ || false;

const http = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    Accept: "application/json",
  },
});

const getErrorCode = (responseData) =>
  responseData?.error?.code || responseData?.code || null;

const shouldForceLogout = (error) => {
  const status = error?.response?.status;
  const responseData = error?.response?.data;
  const code = getErrorCode(responseData);

  if (status === 401 || status === 419 || status === 440) {
    return true;
  }

  // Legacy endpoints often return invalid auth/token as 403.
  return status === 403 && ["TOKEN_INVALID", "SESSION_EXPIRED"].includes(code);
};

export const handleSessionExpiry = () => {
  if (window.__SOPHY_SESSION_EXPIRY_IN_PROGRESS__) {
    return;
  }
  window.__SOPHY_SESSION_EXPIRY_IN_PROGRESS__ = true;
  localStorage.removeItem("access_token");
  localStorage.removeItem("userData");
  localStorage.setItem(SESSION_EXPIRED_FLAG, "1");
  // Always force a full reload to reset in-memory auth state.
  window.location.assign("/");
};

let interceptorRegistered = false;

export const setupAuthInterceptors = () => {
  if (interceptorRegistered) {
    return;
  }

  const responseErrorHandler = (error) => {
    if (shouldForceLogout(error)) {
      handleSessionExpiry();
    }
    return Promise.reject(error);
  };

  http.interceptors.response.use(
    (response) => response,
    responseErrorHandler
  );
  // Catch 401/invalid-token also for modules that still use raw axios.
  axios.interceptors.response.use((response) => response, responseErrorHandler);

  interceptorRegistered = true;
};

// Register interceptors immediately on module load so they are active before
// any component's useEffect can fire an API call (children effects run before
// the App.js parent effect, causing a race condition if we register lazily).
setupAuthInterceptors();

export default http;
